<template>
  <div class="card-body row">
    <div class="col-md-10">
      <div class="row">
        <div class="col col-md-3">
          <div class="list-header">
            Project ID
          </div>
          <div class="list-details" :id="'proj-'+ property.id">
            {{property.projectId || 'None'}}
            <b-tooltip :target="'proj-' + property.id">
              {{property.projectName === null ? 'N/A' : property.projectName}}
            </b-Tooltip>
          </div>
        </div>
        <div class="col col-md-3">
          <div class="list-header">
            Property ID
          </div>
          <div class="list-details">
            {{property.id || 'None'}}
          </div>
        </div>
        <div class="col col-md-3">
          <div class="list-header">
            Property Status
          </div>
          <div class="list-details">
            {{getPropertyStatusName(property.statusId)}}
          </div>
        </div>
        <template v-if="isInstrumentProperty">
          <div class="col-md-3">
            <div class="list-header">
              Impacted Property Acres
            </div>
            <div class="list-details">
              {{propertyInstrument.propertyAcres | acresFormatNullIsNA}}
            </div>
          </div>
        </template>
      </div>
      <template v-if="isInstrumentProperty">
        <hr>
        <div class="row">
          <div class="col-md-3">
            <div class="list-header">
              Properties Allowed
            </div>
            <div class="list-details">
              {{propertyInstrument.futurePropertiesAllowed | numberFormatNullIsNA}}
            </div>
          </div>
          <div class="col-md-3">
            <div class="list-header">
              Dwellings Allowed
            </div>
            <div class="list-details">
              {{propertyInstrument.dwellingsAllowed | numberFormatNullIsNA}}
            </div>
          </div>
          <div class="col-md-3">
            <div class="list-header">
              Finished Area Allowed (sq ft)
            </div>
            <div class="list-details">
              {{propertyInstrument.finishedAreaAllowed | numberFormatNullIsNA}}
            </div>
          </div>
          <div class="col-md-3">
            <div class="list-header">
              Impervious Area Allowed (sq ft)
            </div>
            <div class="list-details">
              {{propertyInstrument.imperviousAreaAllowed | numberFormatNullIsNA}}
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="col-md-2 d-flex justify-content-end align-self-start">
      <b-button
        v-if="!$store.getters['User/isCurrentUserViewOnly'] && isInstrumentProperty"
        class="mr-2"
        variant="secondary"
        size="sm"
        @click="$emit('edit', property.id)"
        aria-label="Edit"
      >
        <font-awesome-icon icon="pen" class="text-white" fixed-width />
      </b-button>
      <template v-if="property.projectId === parseInt($route.params.project_id, 10)">
        <router-link
          :to="{ name: 'projectProperty', params: {
          project_id: property.projectId,
          property_id: property.id }}"
          class="btn btn-secondary btn-sm">
          View
        </router-link>
      </template>
      <template v-if="property.projectId !== parseInt($route.params.project_id, 10)">
        <b-button variant="secondary" size="sm"
          @click="goToOtherProjectForProperty(property.projectId, property.id)">
          View
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'ViewAssociatedProperty',
  props: ['property', 'storeNamespace'],
  computed: {
    propertyInstrument() {
      return this.property.propertyInstruments[0] || null;
    },
    isInstrumentProperty() {
      return this.storeNamespace === EntityModules.ASSOCIATED_PROPERTIES.namespace;
    },
    ...mapGetters(LookupModules.PROPERTY_STATUSES.namespace, {
      getPropertyStatusName: 'getName',
    }),
  },
  methods: {
    goToOtherProjectForProperty(projectId, propertyId) {
      this.$bvModal.msgBoxConfirm(
        `Are you sure you want to go to Project ${projectId}?`,
        {
          okTitle: 'Yes',
          cancelTitle: 'No',
        },
      )
        .then((response) => {
          if (response) {
            this.$store.dispatch('Common/resetAllEditingModes');
            this.$router.push({
              name: 'projectProperty',
              params: { project_id: projectId, property_id: propertyId },
            });
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>
